module.exports = "<section>\n  <header class=\"title\">\n    <span>{{title}}</span>\n  </header>\n  <ul>\n    <li *ngFor=\"let valueInfo of values\">\n      <span class=\"value-label\">{{valueInfo.label}}</span>\n    </li>\n  </ul>\n  <footer class=\"controls\">\n    <button (click)=\"initChanged()\" class=\"btn btn-default\">Change</button>\n  </footer>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/input-list/input-list.component.html
// module id = ../../../../../src/app/modules/ui-form/components/input-list/input-list.component.html
// module chunks = main